import { Image, Resource } from '@/types';
import { ApiService } from '@/services/ApiService';

export class ImageService extends ApiService {
    public uploadImage(file: File): Promise<Resource<Image>> {
        const formData = new FormData();
        formData.append('image', file);

        return this.fetch(route('api.images.upload'), {
            method: 'POST',
            body: formData
        });
    }
}
